import { postAPI } from '../helpers';
import { SolutionsAcceptEmailedOfferResponse } from '../models/hessel-api/solutions-accept-emailed-offer.types';
import { APIResponse } from '../types';

export const postSolutionsAcceptEmailedOffer = async (offerId: string): APIResponse<SolutionsAcceptEmailedOfferResponse> => {
    return await postAPI(`/api/v1/Proxy/solutions-accept-emailed-offer?offerId=${offerId}`);
};
